import { CognitoUserPool } from 'amazon-cognito-identity-js';
import awsmobile from '../../../aws-exports';
export const poolConfig = {
  UserPoolId: awsmobile.aws_user_pools_id! || 'us-east-2_xNtvy8tre',
  ClientId: awsmobile.aws_user_pools_web_client_id! || '3i9cem4oaknavqpob36u02n3f1',
}

export const poolData = (config = poolConfig) => new CognitoUserPool(config);
